import httpClient from '../lib/httpClient';

// API endpoints for operators (read-only)
const apiPath = 'api/products';

// Admin endpoints for full CRUD
const adminPath = 'admin/products';

// Read operations - use /api (operators + admins)
export const listProducts = (query) => httpClient.get(apiPath, { query });
export const getProduct = (id) => httpClient.get(`${apiPath}/${id}`);

// Write operations - use /admin (admins only)
export const createProduct = (payload) => httpClient.post(adminPath, payload);
export const updateProduct = (id, payload) => httpClient.put(`${adminPath}/${id}`, payload);
export const deleteProduct = (id) => httpClient.del(`${adminPath}/${id}`);
export const toggleProductStatus = (id) => httpClient.put(`${adminPath}/${id}/status`, {});

const productServiceExport = { listProducts, getProduct, createProduct, updateProduct, deleteProduct, toggleProductStatus };
export default productServiceExport;
